import { render, staticRenderFns } from "./attraction-card.vue?vue&type=template&id=23000e3d&scoped=true"
import script from "./attraction-card.vue?vue&type=script&lang=js"
export * from "./attraction-card.vue?vue&type=script&lang=js"
import style0 from "./attraction-card.vue?vue&type=style&index=0&id=23000e3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23000e3d",
  null
  
)

export default component.exports